import apiUtils from '@elab/core/utils/apiUtils';
import HTTPClient from '@elab/core/utils/HTTPClient';

const getApiService = userId => `${apiUtils.getBaseUri()}/users/${userId || 'anonymous'}/carts`;

const fetchProductWrapData = async (userId, cartId, productCode, fields = 'FULL') => {
    const uri = `${getApiService(
        userId,
    )}/${cartId}/giftoptions/product/${productCode}?fields=${fields}`;
    const response = await HTTPClient().get(uri);
    if (!response.ok) {
        throw {
            json: await response.json(),
            status: response.status,
            message: response.message,
        };
    }
    return await response.json();
};

const buildGiftWrapProductDTO = giftWrapCode => ({
    configurationLabel: 'giftOptionProductCode',
    configurationValue: giftWrapCode,
    configuratorType: 'GIFTOPTIONS',
    status: 'SUCCESS',
});

const buildGiftWrapMessageDTO = message => ({
    configurationLabel: 'giftOptionMessage',
    configurationValue: message,
    configuratorType: 'GIFTOPTIONS',
    status: 'SUCCESS',
});

const saveGiftWrapData = async ({
    userId,
    cartId,
    entryNumber,
    giftWrapEntries,
    formStepId = 'step_giftOptions',
    isCartOption = false,
}) => {
    const configurationInfos = [];
    giftWrapEntries.forEach(item => {
        const code = item.data ? item.data.code : item.giftOptionCode;
        if (!code) {
            return;
        }
        configurationInfos.push(buildGiftWrapProductDTO(code));
        configurationInfos.push(buildGiftWrapMessageDTO(item.message));
    });

    const uri = isCartOption
        ? `${getApiService(userId)}/${cartId}/giftoptions/step/${formStepId}`
        : `${getApiService(userId)}/${cartId}/giftoptions/step/${formStepId}/entry/${entryNumber}`;
    const response = await HTTPClient().postJson(uri, { configurationInfos });
    if (!response.ok) {
        throw {
            json: await response.json(),
            status: response.status,
            message: response.message,
        };
    }
    return await response.json();
};

export default {
    fetchProductWrapData,
    saveGiftWrapData,
};
